const $ = jQuery.noConflict();

'use strict';

const Register = {

	// properties
	$domForm: null,
	$domLoader: null,
	$domSubmit: null,
	$domResponse: null,

	// initialize
	init: function() {
		if ($('form.js-register__form').length === 0) {
			return; // wrong page
		}
		this.initDom();
		this.bindEvents();
	},
	// set $dom variables
	initDom: function() {
		Register.$domForm = $('.js-register__form');
		Register.$domLoader = $('.loader');
		Register.$domSubmit = $('.js-btn-submit');
		Register.$domResponse = $('.js-response');
		Register.$loader = $('.js-loader');
	},

	// attach events
	bindEvents: function() {
		// intercept submission
		Register.$domForm.on('submit', function() {
			const destiny = Register.validateForm();
			if (destiny === true) {
				Register.sendRequest();
				Register.$domSubmit.addClass('btn-disabled');
			} else {
				Register.responseMessage(destiny, true);
			}
			return false; // always reject
		});
		// btn
		Register.$domSubmit.on('click', function(e) {
			e.preventDefault();
			Register.$domForm.trigger('submit');
		});
		$(document).on('ajaxStart', function() {
			$('.register__btn').find('.loader').addClass('loader--show');
		});
		$(document).on('ajaxComplete', function() {
			$('.register__btn').find('.loader').removeClass('loader--show');
		});
	},

	// check form content
	validateForm: function() {
		const form = Register.$domForm.serializeArray();
		if (form[0].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'First Name is required field.';
		}
		// second field is required
		if (form[1].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Last Name is required field.';
		}
		// first field is required
		if (form[2].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Email address is required field.';
		}
		// Store name is required
		if (form[4].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Store name is required field.';
		}
		// Store address is required
		if (form[5].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Store address is required field.';
		}
		// fourth field is required
		if (form[6].value === '') {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Password is required field.';
		}
		// value length
		if (form[6].value.length < 5) {
			$('html,body').animate({
				scrollTop: $('.register-response').offset().top - 100
			}, 'slow');
			return 'Password should contain at least 5 characters.';
		}

		// validate letter exists
		const regExp = /[a-zA-Z]/g;
		if (!regExp.test(form[6].value)) {
			return 'Please enter at least one letter';
		}

		// validate number exists
		if(!/\d/.test(form[6].value)) {
			return 'Please enter at least one number';
		}
		// validate number exists
		if(form[6].value !== form[7].value) {
			return 'Passwords doesnt match';
		}

		// success
		return true;
	},

	// send form submission
	sendRequest: function() {
		Register.$domSubmit.addClass('btn-disabled');
		Register.$domLoader.show();
		Register.responseMessage('');
		// pack form data
		const formValues = Register.$domForm.serializeArray();
		formValues.push({name: 'action', value: 'register-user'});
		if (window.location.pathname.includes('/checkout/')) {
			formValues.push({name: 'redirect', value: window.location.href});
			localStorage.setItem('donation-login-email', formValues[2].value);
			localStorage.setItem('donation-login-name', `${formValues[0].value} ${formValues[1].value}`);

		} else {
			formValues.push({name: 'redirect', value: window.location.origin + '/my-account/'});
		}
		// dispatch request
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: formValues,
			success: function(response) {
				if (response.success === false) {
					Register.responseMessage(response.data.errors[0], true);
				}
				if (response.success === true && response.data.userId > 0) {
					Register.clearForm();
					Register.$domForm.append('<div class="awaiting_approval-text">Thank you for registering! You will receive an email when your account is approved</div>');
				}
			},
			complete: function() {
				Register.$domSubmit.removeClass('btn-disabled');
				Register.$domLoader.hide();
			}
		});
	},

	// display message
	responseMessage: (msg, asError) => {
		Register.$domResponse
			.html(msg)
			.toggleClass('error-wrap', msg !== '' && asError);
	},

	// empty inputs
	clearForm: function() {
		Register.$domForm.find('input').val('');
	},
};
export default Register;
